import { useEncounter } from '@/contexts/encounter-context';
import { PageContainer } from '@/components/containers/page-container';
import { GradientFormTitle } from '@/components/containers/gradient-form-title';
import { useMediaQuery } from '@/hooks/use-media-query';
import { VisitTitleButtons } from '@/components/navigation/visit-title-buttons';
import { SaveProgressButton } from '@/components/navigation/save-progress-button';
import { ProviderList } from '@/components/encounter/provider/provider-list';
import { SelectedProvider } from '@/components/encounter/provider/selected-provider';
import { useState } from 'react';
import { VisitNavigation } from '@/components/navigation/visit-navigation';
import { useVisitNavigation } from '@/contexts/visit-navigation-context';
import { EncounterStatusIdsType } from '@/api/api.schemas';
import { useTranslation } from '@/contexts/i18n-context';

const translationBase = 'visit.providerSelection';

export function ProviderSelectionPage() {
  const { t } = useTranslation();
  const { encounter } = useEncounter();
  const { hasCompletedStep, editMode } = useVisitNavigation();
  const [editProvider, setEditProvider] = useState(false);
  const isMobile = useMediaQuery('--screen-md');

  const showProviderList =
    editMode ||
    editProvider ||
    (!encounter.preferredProviderId && !hasCompletedStep(EncounterStatusIdsType.ProviderSelection));

  return (
    <PageContainer>
      {!isMobile && <VisitTitleButtons />}
      <GradientFormTitle>
        {isMobile && <VisitTitleButtons />}
        <VisitNavigation />
        <h1 className="h3">{t(`${translationBase}.title`)}</h1>
        <p>{t(`${translationBase}.description`)}</p>
        {isMobile && <SaveProgressButton />}
      </GradientFormTitle>
      {showProviderList ? (
        <ProviderList />
      ) : (
        <SelectedProvider
          providerId={encounter.preferredProviderId}
          onEdit={() => setEditProvider(true)}
        />
      )}
    </PageContainer>
  );
}
